import { Extension } from '@tiptap/core'

export const TemplateExtension = Extension.create({
  name: 'template',

  addStorage() {
    return {
      id: null
    }
  },

  addCommands() {
    return {
      setTemplateId: id => () => {
        // `this.storage` refers to the return value of `addStorage`
        this.storage.id = id
      }
    }
  }
})
